export default __webpack_public_path__ + "static/media/blood-donation.e9e06ebd.png";